module.exports = __webpack_public_path__ + "static/media/8.109ed5f0.jpg";